module.exports = __webpack_public_path__ + "img/logo-full.a4466315.png";